<section class="page">
  <header class="page-header">
    <div>
      <h1>Card programs</h1>
      <p>Manage Kobble card programs for the platform</p>
    </div>
    <div class="header-actions">
      <button class="btn btn-secondary" type="button" (click)="sync()" [disabled]="saving() || loading()">
        Sync from Kobble
      </button>
      <button class="btn btn-primary" type="button" (click)="openCreate()" [disabled]="saving()">
        Create program
      </button>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  @if (showCreate()) {
    <div class="panel create-panel">
      <h2>Create card program</h2>
      <form [formGroup]="form" (ngSubmit)="create()" class="create-form">
        <label>
          <span>Type</span>
          <select formControlName="type">
            <option value="VIRTUAL">VIRTUAL</option>
            <option value="PHYSICAL">PHYSICAL</option>
          </select>
        </label>
        <label>
          <span>Partner product</span>
          <input type="text" formControlName="partner_product" />
        </label>
        <label>
          <span>Name</span>
          <input type="text" formControlName="name" />
        </label>
        <label class="checkbox">
          <input type="checkbox" formControlName="is_default" />
          <span>Set as default</span>
        </label>
        <div class="actions">
          <button class="btn btn-primary" type="submit" [disabled]="saving()">
            {{ saving() ? 'Saving…' : 'Save' }}
          </button>
          <button class="btn btn-secondary" type="button" (click)="cancelCreate()" [disabled]="saving()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  }

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Type</th>
            <th>Partner product</th>
            <th>Kobble ID</th>
            <th>Status</th>
            <th>Default</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="9" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="9" class="muted">No card programs yet</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.name || '—' }}</td>
                <td>{{ row.type || '—' }}</td>
                <td>{{ row.partner_product || '—' }}</td>
                <td class="mono">{{ row.kobble_program_id || '—' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
                </td>
                <td>
                  @if (isDefault(row)) {
                    <span class="badge" data-status="approved">default</span>
                  } @else {
                    —
                  }
                </td>
                <td>{{ row.created_at ? (row.created_at | date: 'mediumDate') : '—' }}</td>
                <td>
                  @if (!isDefault(row)) {
                    <button
                      class="btn btn-secondary btn-sm"
                      type="button"
                      (click)="setDefault(row)"
                      [disabled]="saving()"
                    >
                      Set default
                    </button>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
